import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SdConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'sd-confirm-dialog',
  standalone: false,
  templateUrl: './sd-confirm-dialog.component.html',
  styleUrl: './sd-confirm-dialog.component.scss'
})
export class SdConfirmDialogComponent {
  private data = inject<SdConfirmDialogData>(MAT_DIALOG_DATA);
  matDialog = inject(MatDialogRef<SdConfirmDialogComponent>);

  title = this.data.title;
  message = this.data.message;
  confirmText = this.data.confirmText || 'Confirm';
  cancelText = this.data.cancelText || 'Cancel';
}
